import * as yup from "yup";

const referrerValidation = yup.object().shape(
  {
    firstName: yup.string().when(["lastName", "email"], {
      is: (lastName, email) => !!lastName || !!email,
      then: schema =>
        schema
          .required("First Name is required")
          .min(2, "First Name must be at least 2 characters")
          .max(50, "First Name must be at most 50 characters"),
    }),
    lastName: yup.string().when(["firstName", "email"], {
      is: (firstName, email) => !!firstName || !!email,
      then: schema =>
        schema
          .required("Last Name is required")
          .min(2, "Last Name must be at least 2 characters")
          .max(50, "Last Name must be at most 50 characters"),
    }),
    email: yup.string().when(["firstName", "lastName"], {
      is: (firstName, lastName) => !!firstName || !!lastName,
      then: schema => schema.required("Email is required").email("Email must be a valid email address"),
    }),
  },
  [
    ["firstName", "lastName"],
    ["firstName", "email"],
    ["lastName", "email"],
  ],
);

export default referrerValidation;

